const getTableTopDistance = () => {
  const calcHeight = 'calc(100vh - (70px + 61px + 65px + 1rem + 3rem + 66px + 1rem))';

  return calcHeight;
};

export default getTableTopDistance;
